module.exports = __webpack_public_path__ + "img/applets1icon3.c160194b.png";